import { Calculation, EffectiveDefinition } from '../../models/EffectiveDefinition';
import { TransformCreator, TransformFunction } from '../transform';

export const ConstantType = 'constant';

/**
 * A Constant column calculation
 *
 * Returns the same `value` for every row in the table.
 */
export interface ConstantCalculation extends Calculation {
  readonly type: typeof ConstantType;
  readonly value: number;
}

export const isConstantCalculation = (calc?: Calculation): calc is ConstantCalculation => {
  return calc !== undefined && calc.type === ConstantType;
};

export const constantColumnTransformCreator: TransformCreator = (
  definition: EffectiveDefinition,
  name: string
): TransformFunction => {
  const column = definition.schema[name];
  if (!isConstantCalculation(column.calculation)) {
    throw new Error(`Could not resolve constant calculation with name: ${name}`);
  }
  return constantColumnTransform(name, column.calculation.value);
};

const constantColumnTransform = (name: string, value: number): TransformFunction => {
  return (sourceTable, previousStep) =>
    previousStep.map((record) => {
      let newRecord = { ...record };
      newRecord[name] = value;
      return newRecord;
    });
};
